import React, { useEffect, useRef, useState } from "react"
import { Container, Row, Col, Modal, Button, Form} from 'react-bootstrap';
import Select from 'react-select';
import LoadingSpinner from '../LoadingSpinner/index'
import './EditModal.css'
import config from "../../config/config";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';

const EditModalRank = (props) => {
  const { showModalLabel, setShowModalLabel, selectedRow } = props;
  const [courseNumber, setCourseNumber] = useState('')
  const [timezone, setTimezone] = useState([])
  const [dataRow, setDataRow] = useState({})
  const [isLoading, setIsLoading] = useState(false);
  const [studentId , setStudentId] = useState('')
  const [rank,setRank] = useState([])
  const [label , setLabel] = useState(selectedRow.COURSE_NUMBER)
  const handleCloseModal = () => {
    setShowModalLabel(false)
    setDataRow([])
  }

  const saveDateChanges = async () => {
    dataRow.COURSE_NUMBER = courseNumber
    dataRow.TIMEZONE = timezone.value
    dataRow.RANK = rank
    updateData()
  }
  const updateData = async () => {
    setIsLoading(true)
    const request = {
      'LD_SID': studentId,
      'COURSE_NUMBER': courseNumber,
      'TIMEZONE': timezone.value,
      'RANK' : rank
    }
    let path = config.siteUrl;
    const res = await axios.post(path + '/classes/update-raw-data', request, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',

      }
    })
    if (res.data.status == 200) {
      setIsLoading(false)
      setShowModalLabel(false)
      toast.success(res.data.message)
    } else {
      setIsLoading(false)
      console.log(res)
    }
  }

  const afterHyphen = label.split('-')[1]?.substring(0, 2);
  const lastTwo = label.slice(-2); 
  const labelValue = (`${afterHyphen} - ${lastTwo}`);

  const Options = [
    { value: 'CAPT', label: 'CAPT' },
    { value: 'TSGT', label: 'TSGT' },
    { value: '1st LT', label: '1st LT' },
    { value: '2D LT', label: '2D LT' },
  ];

  useEffect(() => {
    if (selectedRow != undefined) {
      setDataRow(selectedRow)
      setStudentId(selectedRow?.LD_SID)
      setRank(selectedRow.RANK)
      setCourseNumber(selectedRow.COURSE_NUMBER)
      setLabel(selectedRow.COURSE_NUMBER)
    }
  }, [selectedRow])



  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="lg" show={showModalLabel} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>View/Edit Student Data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Form.Label>Schedule For : &nbsp;</Form.Label>
                    <Form.Label>{dataRow.FIRSTNAME + ' ' + dataRow.LASTNAME}</Form.Label>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form" >
                    <Form.Label>Student Timezone : &nbsp;</Form.Label>
                    <Form.Label>{dataRow.TIMEZONE}</Form.Label>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
            
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Form.Label>Level : &nbsp;</Form.Label>
                    <Select className='inputt' type="text"  options={Options}
                      onChange={(e) => { setRank(e.target.value) }
                      }
                      value={labelValue}
                    />
                  </Form.Group>
                </Col>

                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Form.Label>Rank : &nbsp;</Form.Label>
                    <Select
                      name="colors"
                      value={rank}
                      options={Options}
                      className="basic-multi-select "
                      classNamePrefix="select"
                      onChange={(e) => setRank(e)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={() => {
              saveDateChanges()
            }}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default EditModalRank